/**
 * Tipos possíveis de modo de pagamento de rescisão.
 * @typedef {'B' | 'U' | 'RCN' | 'RCO'} ModoPagamentoRescisao
 *
 * - **B** → Bilateral
 * - **U** → Unilateral
 * - **RCN** → Repasse de Crédito - Nova Compra
 * - **RCO** → Repasse de Crédito - Outro Financiamento
 */

/**
 * @typedef {Object} RelatorioItem
 * @property {number} codigo_cobrador - Código identificador do cobrador.
 * @property {string} nome_cobrador - Nome do cobrador.
 * @property {number} codigo_cliente - Código identificador do cliente.
 * @property {string} nome_cliente - Nome completo do cliente.
 * @property {string} nome_empreendimento - Nome do empreendimento relacionado.
 * @property {string} quadra - Identificação da quadra.
 * @property {string} lote - Identificação do lote.
 * @property {number} boleto - Código ou identificador do boleto.
 * @property {number} ge - Número identificador de GE (se aplicável).
 * @property {number} prod - Código do produto.
 * @property {number} codigo_produtividade_tipo - Tipo de produtividade.
 * @property {string|null} descricao - Descrição adicional (ou null).
 * @property {string|null} data_inativacao - Data de inativação (ISO 8601) ou null.
 * @property {string|null} data_transferencia - Data de transferência (ISO 8601) ou null.
 * @property {number} aberto_parc - Quantidade de parcelas em aberto.
 * @property {number} aberto_valor - Valor total em aberto.
 * @property {number} can_parc - Quantidade de parcelas canceladas.
 * @property {number} can_valor - Valor total cancelado.
 * @property {number} pg_par - Quantidade de parcelas pagas.
 * @property {number} pg_valor - Valor total pago (planejado).
 * @property {number} pg_valor_real - Valor total pago (real).
 * @property {number} recebimento - Valor de recebimento.
 * @property {number} divida - Valor da dívida.
 * @property {string} status - Status do registro (ex.: "A" para ativo).
 * @property {ModoPagamentoRescisao} modo_pagamento_resicao - Modo de pagamento da rescisão quando o tipo produtividade for 6.
 */

import React, { useEffect, useState } from 'react';
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Spinner,
  Table,
} from 'react-bootstrap';
import * as constants from '../../constant';
import moment from 'moment';
import { Formik } from 'formik';
import { default as Selector } from 'react-select';
import MaskedInput from 'react-text-mask';
import { FaFileExcel, FaSearch } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import AuthStorage from '~/Utils/AuthStorage';
import { buscarDados, buscarUsuariosCobradores } from '~/Services/Service';
import { salvarEmExcel } from '~/Utils/Helpers';
import GraficoPizza from '~/Components/GraficosComponents/GraficoDePizza';
import GraficoCirculo from '~/Components/GraficosComponents/GraficoDeCirculo';
import GraficoBateria from '~/Components/GraficosComponents/GraficoDeBateria';

import GraficoVelocimetroDesempenhoGeral from '~/Components/GraficosComponents/GraficoDeVelocimetroProdutividade';
import Loading from '~/Components/Loading';
import './style.css';
const ProdutividadeCobradores = () => {
  const user = AuthStorage.getUser();
  const temCaracteristicaAdm = AuthStorage.temCaracteristica(567);
  const empreendimentos = useSelector(state => state.empreendimentos);
  const optionsEmpreendimentos = [
    ...empreendimentos.sort.map(item => ({
      value: item.codigo,
      label: item.codigo + ' - ' + item.descricao,
    })),
  ];
  const [usuarios, setUsuarios] = useState([]);
  const [loadingUsuarios, setLoadingUsuarios] = useState(true);
  const [loadingRelatorio, setLoadingRelatorio] = useState(false);
  const [loadingExcel, setLoadingExcel] = useState(null);
  /**
   * State contendo os dados do relatório.
   * Pode ser `false` (antes de carregar) ou uma lista de itens do relatório.
   * @type {[RelatorioItem[], function]}
   */
  const [dadosRelatorio, setDadosRelatorio] = useState(false);

  const [valorInadimplente, setValorInadimplente] = useState(false);
  const invalidarResultado = () => {
    setDadosRelatorio(false);
    setValorInadimplente(false);
  };
  const [porcentagemVelocimetro, setPorcentagemVelocimetro] = useState(0);
  const [porcentagemRestanteFaixa, setPorcentagemRestanteFaixa] = useState(0);
  const [valorEmDinheiroRestante, setValorEmDinheiroRestante] = useState(0);
  const [valorTotalPago, setValorTotalPago] = useState(0);
  const [valorTotalDivida, setValorTotalDivida] = useState(0);
  const [valorTotalPagoAcordos, setValorTotalPagoAcordos] = useState(0);
  const [valorTotalDividaAcordos, setValorTotalDividaAcordos] = useState(0);
  const [valorTotalAjustadoPorPeso, setValorTotalAjustadoPorPeso] = useState(0);
  const [valorTotalRecebimento, setValorTotalRecebimento] = useState(0);
  const [porcentagemAjustadaPeso, setPorcentagemAjustadaPeso] = useState(0);
  const [percentualPago, setPercentualPago] = useState(0);
  const [percentualRestante, setPercentualRestante] = useState(0);
  const [valoresPenaltisComPeso, setValoresPenaltisComPeso] = useState(0);
  const [valoresAcordosComPeso, setValoresAcordosComPeso] = useState(0);
  const [faixaAtual, setFaixaAtual] = useState(null);
  const [proximaFaixa, setProximaFaixa] = useState(null);
  const [porcentagemReal, setPorcentagemReal] = useState(0);
  const [dadosResolucao, setDadosResolucao] = useState([]);
  const [
    valorPorcentagemAcordosPagos,
    setValorPorcentagemAcordosPagos,
  ] = useState(0);
  const [
    valorPercentualSairamInadimplencia,
    setValorPercentualSairamInadimplencia,
  ] = useState(0);
  const exportarExcel = async tipo => {
    setLoadingExcel(tipo);
    try {
      const dadosParaExcel = dadosRelatorio.map(item => ({
        ...item,
        modo_pagamento_resicao:
          item.modo_pagamento_resicao === 'U'
            ? 'Unilateral'
            : item.modo_pagamento_resicao === 'B'
              ? 'Bilateral'
              : item.modo_pagamento_resicao === 'RCN'
                ? 'Repasse de crédito - Nova Compra'
                : item.modo_pagamento_resicao === 'RCO'
                  ? 'Repasse de Crédito - Outro Financiamento'
                  : item.modo_pagamento_resicao,
      }));

      await salvarEmExcel(
        dadosParaExcel,
        tipo === 'analitico'
          ? '/exportador/excel/relatorio-produtividade-cobradores'
          : '/exportador/excel/relatorio-produtividade-cobradores/consolidado'
      );
    } catch (ex) {
      console.error(ex);
    } finally {
      setLoadingExcel(null);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await buscarUsuariosCobradores();
        const usuariosFormatados = response.map(user => ({
          value: user.codigo,
          label: user.nome,
        }));
        setUsuarios(usuariosFormatados);
      } catch (error) {
        console.error('Erro ao carregar usuários:', error);
      } finally {
        setLoadingUsuarios(false);
      }
    })();
  }, []);

  useEffect(() => {
    if (!dadosRelatorio.length > 0 && !dadosRelatorio) return;
    // A coluna "Valor Corrigido" é a base financeira dos indicadores do dashboard.
    const totalDivida = dadosRelatorio.reduce(
      (acc, item) => acc + item.valor_corrigido,
      0
    );
    //soma da coluna J no excel exportado analitico
    const totalPago = dadosRelatorio.reduce((acc, item) => {
      if (
        item.codigo_produtividade_tipo != 9 &&
        item.codigo_produtividade_tipo != 6
      ) {
        return acc + item.pg_valor;
      }
      return acc + 0;
    }, 0);
    const totalRecebimento = dadosRelatorio.reduce((acc, item) => {
      if (
        item.codigo_produtividade_tipo == 1 ||
        item.codigo_produtividade_tipo == 2 ||
        item.codigo_produtividade_tipo == 3
      ) {
        return acc + item.pg_valor;
      }
      return acc + 0;
    }, 0);
    const totalDividaAcordos = dadosRelatorio.reduce((acc, item) => {
      if (
        item.codigo_produtividade_tipo == 4 ||
        item.codigo_produtividade_tipo == 5
      ) {
        return acc + item.valor_corrigido;
      }
      return acc + 0;
    }, 0);
    const totalPagoAcordos = dadosRelatorio.reduce((acc, item) => {
      if (
        item.codigo_produtividade_tipo == 4 ||
        item.codigo_produtividade_tipo == 5
      ) {
        return acc + item.pg_valor;
      }
      return acc + 0;
    }, 0);
    const totalTransfJuridico = dadosRelatorio.reduce((acc, item) => {
      if (item.codigo_produtividade_tipo == 9) {
        return acc + item.valor_corrigido;
      }
      return acc + 0;
    }, 0);
    const totalRecisaoBilateral = dadosRelatorio.reduce((acc, item) => {
      if (
        item.codigo_produtividade_tipo == 6 &&
        item.modo_pagamento_resicao == 'B'
      ) {
        return acc + item.valor_corrigido;
      }
      return acc + 0;
    }, 0);
    const totalRecisaoUnilateral = dadosRelatorio.reduce((acc, item) => {
      if (
        item.codigo_produtividade_tipo == 6 &&
        item.modo_pagamento_resicao == 'U'
      ) {
        return acc + item.valor_corrigido;
      }
      return acc + 0;
    }, 0);
    const totalRepasseCreditoOutroFinanciamento = dadosRelatorio.reduce(
      (acc, item) => {
        if (
          item.codigo_produtividade_tipo == 6 &&
          item.modo_pagamento_resicao == 'RCO'
        ) {
          return acc + item.valor_corrigido;
        }
        return acc + 0;
      },
      0
    );
    const totalRepasseCreditoNovaCompra = dadosRelatorio.reduce((acc, item) => {
      if (
        item.codigo_produtividade_tipo == 6 &&
        item.modo_pagamento_resicao == 'RCN'
      ) {
        return acc + item.valor_corrigido;
      }
      return acc + 0;
    }, 0);

    const somaValoresParaCalculoInadimplencia =
      totalRecebimento +
      totalDividaAcordos +
      totalRecisaoBilateral +
      totalRecisaoUnilateral +
      totalRepasseCreditoOutroFinanciamento +
      totalRepasseCreditoNovaCompra;
    const porcentagemAcordos = calculaPorcentagem(
      totalPagoAcordos,
      totalDividaAcordos
    );
    const valorAjustadoPesoAcordos =
      (porcentagemAcordos / 100) * totalDividaAcordos;

    setValorPorcentagemAcordosPagos(porcentagemAcordos);
    setValorTotalDividaAcordos(totalDividaAcordos);
    setValorTotalPagoAcordos(valorAjustadoPesoAcordos);

    setValorTotalPago(totalPago);
    setValorTotalDivida(totalDivida);

    const percentualSairamInad = calculaPorcentagem(
      somaValoresParaCalculoInadimplencia,
      totalDivida
    ).toFixed(2);
    setValorPercentualSairamInadimplencia(percentualSairamInad);
    const dadosResolucaoArray = [
      {
        resolucao: 'Recebimento',
        peso: 100,
        valor: totalRecebimento,
        colorRow: '#E7F3FD',
      },
      {
        resolucao: 'Acordos',
        peso: porcentagemAcordos,
        valor: totalDividaAcordos,
        colorRow: '#FFF2D1',
      },
      {
        resolucao: 'Transferência para o Jurídico',
        peso: -5,
        valor: totalTransfJuridico,
        colorRow: '#FFE0E8',
      },
      {
        resolucao: 'Rescisão Bilateral',
        peso: -2.5,
        valor: totalRecisaoBilateral,
        colorRow: '#FFE0E8',
      },
      {
        resolucao: 'Rescisão Unilateral',
        peso: -2.5,
        valor: totalRecisaoUnilateral,
        colorRow: '#FFE0E8',
      },
      {
        resolucao: 'Repasse de Crédito - Outro Financiamento',
        peso: -1,
        valor: totalRepasseCreditoOutroFinanciamento,
        colorRow: '#FFE0E8',
      },
      {
        resolucao: 'Repasse de Crédito - Nova Compra',
        peso: 0,
        valor: totalRepasseCreditoNovaCompra,
        colorRow: '#FFE0E8',
      },
    ];
    setDadosResolucao(dadosResolucaoArray);
    const somaValoresAjustadosPorPeso = dadosResolucaoArray.reduce(
      (acc, item) => {
        const valorAjustado = item.valor * (item.peso / 100);
        return acc + valorAjustado;
      },
      0
    );
    const {
      valorDentroFaixa,
      valorEmDinheiroRestante,
      porcentagemRestanteFaixa,
      velocimetroValue,
      faixaAtual,
      proximaFaixa,
      porcentagemReal,
    } = calcularPorcentagemVelocimetro(
      totalDivida,
      somaValoresAjustadosPorPeso
    );

    setPorcentagemVelocimetro(Number(velocimetroValue.toFixed(2)));
    setValorEmDinheiroRestante(valorEmDinheiroRestante);
    setPorcentagemRestanteFaixa(Number(porcentagemRestanteFaixa.toFixed(2)));
    setFaixaAtual(faixaAtual);
    setProximaFaixa(proximaFaixa);
    setPorcentagemReal(porcentagemReal);
    setValorTotalRecebimento(totalRecebimento);
    setValorTotalAjustadoPorPeso(somaValoresAjustadosPorPeso || 0);
    const percentualPago = (somaValoresAjustadosPorPeso / totalDivida) * 100;
    const percentualRestante = 100 - percentualPago;
    setPercentualPago(Number(percentualPago.toFixed(2)));
    setPercentualRestante(Number(percentualRestante.toFixed(2)));
    const somaValoresAcordosComPeso = dadosResolucaoArray
      .filter(item => item.resolucao === 'Acordos')
      .reduce((acc, item) => acc + item.valor * (item.peso / 100), 0);

    setValoresAcordosComPeso(somaValoresAcordosComPeso);
    const penalidades = [
      'Transferência para o Jurídico',
      'Rescisão Bilateral',
      'Rescisão Unilateral',
      'Repasse de Crédito - Outro Financiamento',
      'Repasse de Crédito - Nova Compra',
    ];
    const somaValoresPenaltisComPeso = dadosResolucaoArray
      .filter(item => penalidades.includes(item.resolucao))
      .reduce((acc, item) => acc + item.valor * (item.peso / 100), 0);

    setValoresPenaltisComPeso(somaValoresPenaltisComPeso);

    const porcentagemAjustadaPeso = calculaPorcentagem(
      somaValoresAjustadosPorPeso,
      totalDivida
    ).toFixed(2);
    setPorcentagemAjustadaPeso(porcentagemAjustadaPeso);
  }, [dadosRelatorio]);

  const calculaPorcentagem = (n1, n2) => {
    if (n1 == 0 || n2 == 0) return 0;
    return (n1 / n2) * 100;
  };

  const calcularPorcentagemVelocimetro = (valorDivida, valorPago) => {
    let porcentagemReal = (valorPago / valorDivida) * 100;
    let porcentagemRealArredondado = porcentagemReal.toFixed(2);

    if (porcentagemReal < 80) {
      const velocimetroValue = (porcentagemReal / 79.99) * 100;

      const valorProximaFaixa = valorDivida * 0.8;
      const valorEmDinheiroRestante = valorProximaFaixa - valorPago;

      const porcentagemRestanteFaixa = 100 - velocimetroValue;

      return {
        valorDentroFaixa: velocimetroValue,
        valorEmDinheiroRestante,
        porcentagemRestanteFaixa,
        velocimetroValue: velocimetroValue,
        faixaAtual: null,
        proximaFaixa: 80,
        porcentagemReal,
      };
    }

    const porcentagemAcimaDe80 = porcentagemRealArredondado - 80;
    const faixaAtual = Math.floor(porcentagemAcimaDe80);
    const progressoDentroFaixa = porcentagemAcimaDe80 - faixaAtual;

    const velocimetroValue = (progressoDentroFaixa / 0.99) * 100;

    const proximaFaixa = 80 + faixaAtual + 1;
    const valorProximaFaixa = valorDivida * (proximaFaixa / 100);
    const valorEmDinheiroRestante = valorProximaFaixa - valorPago;
    const porcentagemRestanteFaixa = 100 - velocimetroValue;

    return {
      valorDentroFaixa: velocimetroValue,
      valorEmDinheiroRestante,
      porcentagemRestanteFaixa,
      velocimetroValue: velocimetroValue,
      faixaAtual: 80 + faixaAtual,
      proximaFaixa,
      porcentagemRealArredondado,
    };
  };
  const calcularRemuneracaoFaixa = faixa => {
    if (faixa === null || faixa < 80) return null;
    const nivel = Math.floor(faixa) - 80;
    const tem568 = AuthStorage.temCaracteristica(568);
    const tem583 = AuthStorage.temCaracteristica(583);
    const formatar = v =>
      v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

    if (temCaracteristicaAdm) {
      const recebiveis = 150 + nivel * 50;
      const setClube = 120 + nivel * 20;
      return `${formatar(recebiveis)} (Recebíveis) / ${formatar(setClube)} (SetClube)`;
    }
    if (tem583) return formatar(120 + nivel * 20);
    return formatar(150 + nivel * 50);
  };

  const handleSubmitRelatorio = values => {
    const usuarios = values.usuarios.map(item => {
      return item || null;
    });

    const objRequest = {
      data_inicial: values.data_inicial.format
        ? values.data_inicial.format('YYYY-MM-DD')
        : moment(values.data_inicial, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      data_final: values.data_final.format
        ? values.data_final.format('YYYY-MM-DD')
        : moment(values.data_final, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      codigos_empreendimentos: values.codigo_empreendimento,
      codigo_usuario_sessao: user.usuario,
      codigo_usuarios_cobradores: usuarios,
    };

    (async () => {
      try {
        setLoadingRelatorio(true);
        var response = await buscarDados(objRequest);
      } catch (error) {
      } finally {
        setLoadingRelatorio(false);
      }
      setDadosRelatorio(response.lista_relatorio);
      setValorInadimplente(response.valor_inadimplencia);
    })();
  };
  const isValidDate = dateString => {
    if (!dateString || dateString.length < 10) return false;

    const moment_date = moment(dateString, 'DD/MM/YYYY', true);
    return moment_date.isValid();
  };
  return (
    <>
      <Formik
        onSubmit={handleSubmitRelatorio}
        initialValues={{
          codigo_empreendimento: '',
          data_inicial: moment()
            .add(-1, 'months')
            .format('DD/MM/YYYY'),
          data_final: moment().format('DD/MM/YYYY'),
          usuarios: user.usuario && !temCaracteristicaAdm ? [user.usuario] : [],
        }}
        validate={values => {
          const errors = {};
          const dataMinima = moment('2025-03-11', 'YYYY-MM-DD');

          if (!values.data_inicial) {
            errors.data_inicial = 'Data inicial é obrigatória.';
          } else if (!isValidDate(values.data_inicial)) {
            errors.data_inicial = 'Formato de data inválido.';
          } else if (
            moment(values.data_inicial, 'DD/MM/YYYY').isBefore(
              dataMinima,
              'day'
            )
          ) {
            errors.data_inicial =
              'A data inicial não pode ser antes de 11/03/2025.';
          }

          if (!values.data_final) {
            errors.data_final = 'Data final é obrigatória.';
          } else if (!isValidDate(values.data_final)) {
            errors.data_final = 'Formato de data inválido.';
          } else if (
            values.data_inicial &&
            isValidDate(values.data_inicial) &&
            moment(values.data_final, 'DD/MM/YYYY').isBefore(
              moment(values.data_inicial, 'DD/MM/YYYY'),
              'day'
            )
          ) {
            errors.data_final =
              'A data final não pode ser antes da data inicial.';
          }

          return errors;
        }}
      >
        {({
          handleSubmit,
          values,
          handleChange,
          setFieldValue,
          errors,
          touched,
        }) => (
          <div className="CardRelatorioFiltro">
            <Col>
              <Card>
                <Card.Body>
                  <form onSubmit={handleSubmit}>
                    <Row className="">
                      <Col
                        xs="12"
                        lg={"3"}
                        className="p-0"
                      >
                        <Form.Group controlId="filtro.codigo_empreendimento">
                          <Form.Label>Empreendimento</Form.Label>
                          <Selector
                            noOptionsMessage={() =>
                              'Nenhum empreendimento encontrado'
                            }
                            isMulti={true}
                            disabled={
                              optionsEmpreendimentos.length < 1 ||
                              loadingExcel ||
                              loadingRelatorio
                            }
                            placeholder="Selecionar empreendimento..."
                            options={optionsEmpreendimentos}
                            styles={{
                              control: base => ({
                                ...base,
                                maxHeight: 'auto',
                                overflow: 'hidden',
                                minHeight: '38px',
                              }),
                              valueContainer: base => ({
                                ...base,
                                maxHeight: '55px',
                                overflowY: 'auto',
                                flexWrap: 'wrap',
                              }),
                              multiValue: base => ({
                                ...base,
                                maxWidth: '100%',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }),
                            }}
                            onChange={selectedOptions => {
                              setFieldValue(
                                'codigo_empreendimento',
                                selectedOptions
                                  ? selectedOptions.map(option => option.value)
                                  : ''
                              );
                              invalidarResultado();
                            }}
                            isDisabled={loadingExcel || loadingRelatorio}
                          />
                        </Form.Group>
                      </Col>

                      {temCaracteristicaAdm && (
                        <Col xs="12" lg="3">
                          <Form.Group controlId="filtro.usuarios">
                            <Form.Label>Usuários</Form.Label>
                            <Selector
                              isMulti
                              isLoading={loadingUsuarios}
                              placeholder="Selecionar usuários..."
                              options={usuarios}
                              defaultValue={
                                values.usuarios.length > 0
                                  ? values.usuarios
                                  : false
                              }
                              onChange={selectedOptions => {
                                setFieldValue(
                                  'usuarios',
                                  selectedOptions
                                    ? selectedOptions.map(o => o.value)
                                    : []
                                );
                                invalidarResultado();
                              }}
                              styles={{
                                control: base => ({
                                  ...base,
                                  maxHeight: 'auto',
                                  overflow: 'hidden',
                                  minHeight: '38px',
                                }),
                                valueContainer: base => ({
                                  ...base,
                                  maxHeight: '55px',
                                  overflowY: 'auto',
                                  flexWrap: 'wrap',
                                }),
                                multiValue: base => ({
                                  ...base,
                                  maxWidth: '100%',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                }),
                              }}
                              isDisabled={loadingExcel || loadingRelatorio}
                            />
                          </Form.Group>
                        </Col>
                      )}

                      <Col xs="12" sm="6" lg="2">
                        <Form.Group
                          controlId="filtro.data_inicial"
                          className=""
                        >
                          <Form.Label>Data Inicial</Form.Label>
                          <MaskedInput
                            name="data_inicial"
                            type="tel"
                            guide={false}
                            className={`form-control ${errors.data_inicial && touched.data_inicial
                              ? 'is-invalid'
                              : ''
                              }`}
                            placeholder="Ex.: 01/01/2024"
                            mask={constants.MASK_DATE}
                            value={String(values.data_inicial) || ''}
                            onChange={e => {
                              setFieldValue('data_inicial', e.target.value);
                              invalidarResultado();
                            }}
                            disabled={loadingExcel || loadingRelatorio}
                          />
                          <Form.Control.Feedback
                            type="invalid"
                            className="d-block"
                          >
                            {errors.data_inicial}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col xs="12" sm="6" lg="2">
                        <Form.Group controlId="filtro.data_final">
                          <Form.Label>Data Final</Form.Label>
                          <MaskedInput
                            name="data_final"
                            type="tel"
                            guide={false}
                            className={`form-control ${errors.data_final && touched.data_final
                              ? 'is-invalid'
                              : ''
                              }`}
                            placeholder="Ex.: 01/01/2024"
                            mask={constants.MASK_DATE}
                            value={String(values.data_final) || ''}
                            onChange={e => {
                              setFieldValue('data_final', e.target.value);
                              invalidarResultado();
                            }}
                            disabled={loadingExcel || loadingRelatorio}
                          />
                          <Form.Control.Feedback
                            type="invalid"
                            className="d-block"
                          >
                            {errors.data_final}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col xs="12" lg="2" className="d-flex align-items-start">
                        <div className="w-100">
                          <Form.Label className="invisible">Ação</Form.Label>{' '}
                          <Button
                            variant="outline-primary"
                            type="submit"
                            disabled={
                              loadingRelatorio ||
                              Object.values(errors).length > 0
                            }
                            className="w-100"
                          >
                            <FaSearch />
                            <span className="ms-1">
                              {loadingRelatorio
                                ? 'Carregando...'
                                : 'Gerar Relatório'}
                            </span>
                          </Button>
                        </div>
                      </Col>
                    </Row>
                    <Row className='justify-content-end'>
                      {dadosRelatorio.length > 0 && !loadingRelatorio && (
                        <Col
                          xs="12"
                          md="auto"
                          className=""
                        >
                          <Form.Label className="invisible">Ação</Form.Label>{' '}
                          <div className="d-flex" style={{ gap: '0.1rem' }}>
                            <Button
                              variant="success"
                              onClick={() => exportarExcel('analitico')}
                              disabled={loadingExcel}
                              className=""
                            >
                              {loadingExcel === 'analitico' ? (
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                />
                              ) : (
                                <>
                                  <FaFileExcel className="mb-1" /> Analítico
                                </>
                              )}
                            </Button>
                            <Button
                              variant="success"
                              onClick={() => exportarExcel('consolidado')}
                              disabled={loadingExcel}
                            >
                              {loadingExcel === 'consolidado' ? (
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                />
                              ) : (
                                <>
                                  <FaFileExcel className="mb-1" /> Consolidado
                                </>
                              )}
                            </Button>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </form>
                </Card.Body>
              </Card>
            </Col>
          </div>
        )}
      </Formik>
      {loadingRelatorio ? (
        <div className="text-center my-5">
          <Loading></Loading>
        </div>
      ) : dadosRelatorio.length > 0 ? (
        <Container fluid className="mt-4">
          <Row className="g-4 mt-4 mb-4">
            <Col xs="12">
              <Card className="shadow-sm">
                <Card.Header className="bg-info text-white">
                  <h6 className="mb-0">
                    <i className="fas fa-chart-bar me-2"></i>
                    Resumo Estatístico
                  </h6>
                </Card.Header>
                <Card.Body>
                  <Row className="text-center justify-content-between">
                    <Col md="3" sm="6" className="border-end">
                      <div className="p-3">
                        <small className="text-muted">Total em Dívida</small>
                        <h4
                          className=" mb-1"
                          style={{
                            color: '#e90d0dff',
                          }}
                        >
                          {valorTotalDivida.toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                          })}
                        </h4>
                      </div>
                    </Col>
                    <Col md="3" sm="6" className="border-end">
                      <div className="p-3">
                        <small className="text-muted">Total Recuperado</small>
                        <h4
                          className=" mb-1"
                          style={{
                            color: '#000000ff',
                          }}
                        >
                          {valorTotalPago.toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                          })}
                        </h4>
                      </div>
                    </Col>
                    <Col md="2" sm="6" className="border-end">
                      <div className="p-3">
                        <small className="text-muted">
                          Taxa de Inadimplência
                        </small>
                        <h4
                          className="mb-1"
                          style={{
                            color: '#000000ff',
                          }}
                        >
                          {typeof valorInadimplente === 'number'
                            ? valorInadimplente.toFixed(2)
                            : valorInadimplente}
                          %
                        </h4>
                      </div>
                    </Col>
                    <Col md="2" sm="6">
                      <div className="p-3">
                        <small className="text-muted">
                          Quantidade de Contratos
                        </small>
                        <h4
                          className="mb-1"
                          style={{
                            color: 'black',
                          }}
                        >
                          {dadosRelatorio.length}
                        </h4>
                      </div>
                    </Col>
                    <Col md="2" sm="6">
                      <div className="p-3">
                        <small className="text-muted">
                          Quantidade de Clientes
                        </small>
                        <h4
                          className="mb-1"
                          style={{
                            color: 'black',
                          }}
                        >
                          {
                            new Set(
                              dadosRelatorio.map(item => item.codigo_cliente)
                            ).size
                          }
                        </h4>
                      </div>
                    </Col>
                  </Row>
                  <Row className="text-center">
                    <Col md="3" sm="6" className="border-end">
                      <div className="p-3">
                        <small className="text-muted">
                          Saíram da Inadimplência
                        </small>
                        <h4
                          className=" mb-1"
                          style={{
                            color: '#000000ff',
                          }}
                        >
                          {valorPercentualSairamInadimplencia || 0}%
                        </h4>
                      </div>
                    </Col>
                    <Col md="3" sm="6" className="border-end">
                      <div className="p-3">
                        <small className="text-muted">
                          Total Ajustado por Peso
                        </small>
                        <h4
                          className="mb-1"
                          style={{
                            color: '#000000ff',
                          }}
                        >
                          {valorTotalAjustadoPorPeso.toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                          })}
                        </h4>
                      </div>
                    </Col>
                    <Col md="3" sm="6" className="border-end">
                      <div className="p-3">
                        <small className="text-muted">
                          Percentual Ajustado por Peso
                        </small>
                        <h4
                          className="mb-1"
                          style={{
                            color: '#0bd815ff',
                          }}
                        >
                          {porcentagemAjustadaPeso}%
                        </h4>
                      </div>
                    </Col>
                    <Col md="3" sm="6">
                      <div className="p-3">
                        <small className="text-muted">
                          Percentual de Acordos Recebidos
                        </small>
                        <h4
                          className="mb-1"
                          style={{
                            color: '#000000ff',
                          }}
                        >
                          {valorPorcentagemAcordosPagos.toFixed(2)}%
                        </h4>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="g-4 mb-4">
            <Col xl="12" lg="12" md="12">
              <Card className="h-100 w-100 shadow-sm border-0">
                <Card.Header className="bg-gradient bg-primary text-white border-0 py-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <h6 className="mb-0 fw-bold">
                      <i className="fas fa-chart-pie me-2"></i>
                      Resolução de Cobranças
                    </h6>
                  </div>
                </Card.Header>
                <Card.Body className="p-4">
                  <Row>
                    <Col lg="7">
                      <div className="mb-4 p-3 bg-light rounded-3">
                        <div className="d-flex align-items-center justify-content-between">
                          <div>
                            <small className="text-muted text-uppercase fw-semibold d-block mb-1">
                              Total da Carteira
                            </small>
                            <h3 className="mb-0 text-primary fw-bold">
                              {valorTotalDivida.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                              })}
                            </h3>
                          </div>
                          <div className="text-end">
                            <small className="text-muted d-block">
                              {dadosResolucao.length} categorias
                            </small>
                          </div>
                        </div>
                      </div>

                      <div
                        className="table-responsive"
                        style={{ overflow: 'hidden' }}
                      >
                        <table className="table table-hover align-middle mb-0">
                          <thead>
                            <tr className="border-0">
                              <th className="border-0 bg-transparent text-muted small fw-semibold text-uppercase pb-3">
                                Tipo de Resolução
                              </th>
                              <th className="border-0 bg-transparent text-muted small fw-semibold text-uppercase text-center pb-3">
                                Peso
                              </th>
                              <th className="border-0 bg-transparent text-muted small fw-semibold text-uppercase text-end pb-3">
                                Valor
                              </th>
                              <th className="border-0 bg-transparent text-muted small fw-semibold text-uppercase text-end pb-3">
                                Valor Ajustado
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {dadosResolucao.map((item, index) => {
                              const getIcon = () => {
                                if (item.resolucao.includes('Recebimento'))
                                  return 'fas fa-check-circle text-success';
                                if (item.resolucao.includes('Acordos'))
                                  return 'fas fa-handshake text-warning';
                                if (item.resolucao.includes('Jurídico'))
                                  return 'fas fa-gavel text-danger';
                                if (item.resolucao.includes('Rescisão'))
                                  return 'fas fa-times-circle text-danger';
                                if (item.resolucao.includes('Repasse'))
                                  return 'fas fa-exchange-alt text-info';
                                return 'fas fa-circle text-secondary';
                              };

                              const getRowStyle = () => {
                                let bgColor = '';
                                let borderColor = '';

                                if (item.colorRow === '#E7F3FD') {
                                  bgColor = 'rgba(13, 110, 253, 0.05)';
                                  borderColor = 'rgba(13, 110, 253, 0.2)';
                                } else if (item.colorRow === '#FFF2D1') {
                                  bgColor = 'rgba(255, 193, 7, 0.05)';
                                  borderColor = 'rgba(255, 193, 7, 0.2)';
                                } else if (item.colorRow === '#FFE0E8') {
                                  bgColor = 'rgba(220, 53, 69, 0.05)';
                                  borderColor = 'rgba(220, 53, 69, 0.2)';
                                }

                                return {
                                  backgroundColor: bgColor,
                                  borderLeft: `4px solid ${borderColor}`,
                                  transition:
                                    'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                };
                              };

                              const getPesoColor = () => {
                                if (item.peso >= 50) return 'text-success';
                                if (item.peso > 0) return 'text-warning';
                                if (item.peso === 0) return 'text-muted';
                                return 'text-danger';
                              };

                              return (
                                <tr
                                  key={index}
                                  style={getRowStyle()}
                                  className="border-bottom"
                                  onMouseEnter={e => {
                                    e.currentTarget.style.transform =
                                      'scale(1.02)';
                                    e.currentTarget.style.boxShadow =
                                      '0 8px 30px rgba(0,0,0,0.12)';
                                    e.currentTarget.style.zIndex = '1';
                                    e.currentTarget.style.borderLeftWidth =
                                      '6px';
                                  }}
                                  onMouseLeave={e => {
                                    e.currentTarget.style.transform =
                                      'scale(1)';
                                    e.currentTarget.style.boxShadow = 'none';
                                    e.currentTarget.style.zIndex = 'auto';
                                    e.currentTarget.style.borderLeftWidth =
                                      '4px';
                                  }}
                                >
                                  <td className="py-3 border-0">
                                    <div className="d-flex align-items-center">
                                      <i
                                        className={`${getIcon()} me-3 fs-5`}
                                      ></i>
                                      <div>
                                        <span className="fw-semibold d-block">
                                          {item.resolucao}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="text-center py-3 border-0">
                                    <span
                                      className={`badge bg-light ${getPesoColor()} fw-bold px-3 py-2`}
                                    >
                                      {item.peso > 0 && '+'}
                                      {typeof item.peso === 'number'
                                        ? item.peso.toFixed(2)
                                        : item.peso}
                                      %
                                    </span>
                                  </td>
                                  <td className="text-end py-3 border-0">
                                    <span className="fw-bold">
                                      {item.valor.toLocaleString('pt-BR', {
                                        style: 'currency',
                                        currency: 'BRL',
                                      })}
                                    </span>
                                  </td>
                                  <td className="text-end py-3 border-0">
                                    <div>
                                      <span className="fw-bold d-block">
                                        {(
                                          item.valor *
                                          (item.peso / 100)
                                        ).toLocaleString('pt-BR', {
                                          style: 'currency',
                                          currency: 'BRL',
                                        })}
                                      </span>
                                      {item.peso !== 0 && (
                                        <small
                                          className={
                                            item.peso > 0
                                              ? 'text-success'
                                              : 'text-danger'
                                          }
                                        >
                                          <i
                                            className={`fas fa-arrow-${item.peso > 0 ? 'up' : 'down'
                                              } me-1`}
                                          ></i>
                                          {typeof item.peso === 'number'
                                            ? Math.abs(item.peso).toFixed(2)
                                            : Math.abs(item.peso)}
                                          % impacto
                                        </small>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </Col>

                    <Col
                      lg="5"
                      style={{
                        alignSelf: 'center',
                      }}
                    >
                      <div
                        className="ps-lg-4"
                        style={{ justifyItems: 'center' }}
                      >
                        <GraficoPizza
                          totalRecebimento={valorTotalRecebimento}
                          totalAcordos={valoresAcordosComPeso}
                          totalPenaltis={valoresPenaltisComPeso}
                        />
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="mb-4">
            <Col xl="6" lg="6" md="12">
              <Card className="h-100 shadow-sm">
                <Card.Header className="bg-success text-white">
                  <h6 className="mb-0">
                    <i className="fas fa-battery-three-quarters me-2"></i>
                    Nível de Produtividade de Negociação
                  </h6>
                </Card.Header>
                <Card.Body className="d-flex align-items-center justify-content-center p-0">
                  <GraficoBateria
                    totalDivida={valorTotalDividaAcordos}
                    totalPago={valorTotalPagoAcordos}
                  />
                </Card.Body>
              </Card>
            </Col>
            <Col xl="6" lg="6" md="12">
              <Card className="h-100 shadow-sm">
                <Card.Header
                  className="text-white"
                  style={{ backgroundColor: '#7F41EF' }}
                >
                  <h6 className="mb-0">
                    <i className="fas fa-tachometer-alt me-2"></i>
                    Nível de Produtividade Geral
                  </h6>
                </Card.Header>
                <Card.Body className="d-flex align-items-center justify-content-center p-0">
                  <GraficoVelocimetroDesempenhoGeral
                    valorTotalRecebimento={valorTotalAjustadoPorPeso}
                    valorTotalDivida={valorTotalDivida - valorTotalAjustadoPorPeso}
                    porcentagemDeGanhos={percentualPago}
                    porcentagemDoQueFalta={percentualRestante}
                    labelProgressao="Progresso Atual"
                    labelRestante="Restante"
                    labelRecebido="Valor Meta"
                  />
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row className="g-4 mb-4">
            <Col xl="6" lg="6" md="12">
              <Card className="h-100 shadow-sm">
                <Card.Header className="bg-danger text-white">
                  <h6 className="mb-0">
                    <i className="fas fa-exclamation-triangle me-2"></i>
                    Taxa de Inadimplência atual
                  </h6>
                </Card.Header>
                <Card.Body className="d-flex align-items-center justify-content-center p-0">
                  <GraficoCirculo dados={valorInadimplente} />
                </Card.Body>
              </Card>
            </Col>
            <Col xl="6" lg="6" md="12">
              <Card className="h-100 shadow-sm">
                <Card.Header className="bg-warning text-white">
                  <h6 className="mb-0">
                    <i className="fas fa-tachometer-alt me-2"></i>
                    Progressão de Faixas
                  </h6>
                  {faixaAtual !== null && proximaFaixa !== null && (
                    <small className="d-block">
                      Faixa atual: <strong>{faixaAtual}%</strong> → Meta:{' '}
                      <strong>{proximaFaixa}%</strong> — Faixa:{' '}
                      <strong>{faixaAtual}%</strong> a{' '}
                      <strong>{(faixaAtual + 0.99).toFixed(2)}%</strong>
                    </small>
                  )}
                </Card.Header>
                <Card.Body className="d-flex align-items-center justify-content-center p-0">
                  <GraficoVelocimetroDesempenhoGeral
                    titulo="Indicador de Desempenho"
                    valorTotalRecebimento={valorTotalAjustadoPorPeso}
                    valorTotalDivida={valorEmDinheiroRestante}
                    porcentagemDeGanhos={porcentagemVelocimetro}
                    porcentagemDoQueFalta={porcentagemRestanteFaixa}
                    inicioFaixa={faixaAtual !== null ? faixaAtual : null}
                    fimFaixa={
                      faixaAtual !== null
                        ? parseFloat((faixaAtual + 0.99).toFixed(2))
                        : null
                    }
                    valorFaixa={calcularRemuneracaoFaixa(faixaAtual)}
                    exibirStatus={false}
                  />
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {(() => {
            const temCaracteristica568 = AuthStorage.temCaracteristica(568);
            const temCaracteristica583 = AuthStorage.temCaracteristica(583);
            const temCaracteristica567 = AuthStorage.temCaracteristica(567);

            const exibeAmbas = temCaracteristica567;
            const exibeApenasSetClube = !exibeAmbas && temCaracteristica583;
            const exibeApenasRecebiveis =
              !exibeAmbas && !temCaracteristica583 && temCaracteristica568;

            const colSize = exibeAmbas ? '6' : '12';

            if (!exibeApenasRecebiveis && !exibeApenasSetClube && !exibeAmbas) {
              return null;
            }

            return (
              <Row className="g-4 mb-4">
                {(exibeApenasRecebiveis || exibeAmbas) && (
                  <Col xl={colSize} lg={colSize} md="12">
                    <Card className="h-100 shadow-sm border-0">
                      <Card.Header className="bg-gradient bg-primary text-white border-0 py-3">
                        <div className="d-flex justify-content-between align-items-center">
                          <h6 className="mb-0 fw-bold">
                            <i className="fas fa-table me-2"></i>
                            Tabela Recebíveis
                          </h6>
                        </div>
                      </Card.Header>
                      <Card.Body className="p-4">
                        <div
                          className="table-responsive"
                          style={{ overflow: 'hidden' }}
                        >
                          <table className="table table-hover align-middle mb-0">
                            <thead>
                              <tr className="border-0">
                                <th className="border-0 bg-transparent text-muted small fw-semibold text-uppercase text-center pb-3">
                                  Percentual
                                </th>
                                <th className="border-0 bg-transparent text-muted small fw-semibold text-uppercase text-end pb-3">
                                  Remuneração
                                </th>
                                <th className="border-0 bg-transparent text-muted small fw-semibold text-uppercase text-center pb-3">
                                  Percentual
                                </th>
                                <th className="border-0 bg-transparent text-muted small fw-semibold text-uppercase text-end pb-3">
                                  Remuneração
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                className="border-bottom"
                                style={{
                                  backgroundColor: 'rgba(13, 110, 253, 0.05)',
                                  borderLeft:
                                    '4px solid rgba(13, 110, 253, 0.2)',
                                  transition:
                                    'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }}
                                onMouseEnter={e => {
                                  e.currentTarget.style.transform =
                                    'scale(1.02)';
                                  e.currentTarget.style.boxShadow =
                                    '0 8px 30px rgba(0,0,0,0.12)';
                                  e.currentTarget.style.zIndex = '1';
                                  e.currentTarget.style.borderLeftWidth = '6px';
                                }}
                                onMouseLeave={e => {
                                  e.currentTarget.style.transform = 'scale(1)';
                                  e.currentTarget.style.boxShadow = 'none';
                                  e.currentTarget.style.zIndex = 'auto';
                                  e.currentTarget.style.borderLeftWidth = '4px';
                                }}
                              >
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    50% a 52,49%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 350,00</span>
                                </td>
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    75% a 77,49%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 700,00</span>
                                </td>
                              </tr>
                              <tr
                                className="border-bottom"
                                style={{
                                  backgroundColor: 'rgba(13, 110, 253, 0.05)',
                                  borderLeft:
                                    '4px solid rgba(13, 110, 253, 0.2)',
                                  transition:
                                    'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }}
                                onMouseEnter={e => {
                                  e.currentTarget.style.transform =
                                    'scale(1.02)';
                                  e.currentTarget.style.boxShadow =
                                    '0 8px 30px rgba(0,0,0,0.12)';
                                  e.currentTarget.style.zIndex = '1';
                                  e.currentTarget.style.borderLeftWidth = '6px';
                                }}
                                onMouseLeave={e => {
                                  e.currentTarget.style.transform = 'scale(1)';
                                  e.currentTarget.style.boxShadow = 'none';
                                  e.currentTarget.style.zIndex = 'auto';
                                  e.currentTarget.style.borderLeftWidth = '4px';
                                }}
                              >
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    52,50% a 54,99%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 385,00</span>
                                </td>
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    77,50% a 79,99%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 745,00</span>
                                </td>
                              </tr>
                              <tr
                                className="border-bottom"
                                style={{
                                  backgroundColor: 'rgba(13, 110, 253, 0.05)',
                                  borderLeft:
                                    '4px solid rgba(13, 110, 253, 0.2)',
                                  transition:
                                    'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }}
                                onMouseEnter={e => {
                                  e.currentTarget.style.transform =
                                    'scale(1.02)';
                                  e.currentTarget.style.boxShadow =
                                    '0 8px 30px rgba(0,0,0,0.12)';
                                  e.currentTarget.style.zIndex = '1';
                                  e.currentTarget.style.borderLeftWidth = '6px';
                                }}
                                onMouseLeave={e => {
                                  e.currentTarget.style.transform = 'scale(1)';
                                  e.currentTarget.style.boxShadow = 'none';
                                  e.currentTarget.style.zIndex = 'auto';
                                  e.currentTarget.style.borderLeftWidth = '4px';
                                }}
                              >
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    55% a 57,49%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 420,00</span>
                                </td>
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    80% a 82,49%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 790,00</span>
                                </td>
                              </tr>
                              <tr
                                className="border-bottom"
                                style={{
                                  backgroundColor: 'rgba(13, 110, 253, 0.05)',
                                  borderLeft:
                                    '4px solid rgba(13, 110, 253, 0.2)',
                                  transition:
                                    'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }}
                                onMouseEnter={e => {
                                  e.currentTarget.style.transform =
                                    'scale(1.02)';
                                  e.currentTarget.style.boxShadow =
                                    '0 8px 30px rgba(0,0,0,0.12)';
                                  e.currentTarget.style.zIndex = '1';
                                  e.currentTarget.style.borderLeftWidth = '6px';
                                }}
                                onMouseLeave={e => {
                                  e.currentTarget.style.transform = 'scale(1)';
                                  e.currentTarget.style.boxShadow = 'none';
                                  e.currentTarget.style.zIndex = 'auto';
                                  e.currentTarget.style.borderLeftWidth = '4px';
                                }}
                              >
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    57,50% a 59,99%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 455,00</span>
                                </td>
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    82,50% a 84,99%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 835,00</span>
                                </td>
                              </tr>
                              <tr
                                className="border-bottom"
                                style={{
                                  backgroundColor: 'rgba(13, 110, 253, 0.05)',
                                  borderLeft:
                                    '4px solid rgba(13, 110, 253, 0.2)',
                                  transition:
                                    'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }}
                                onMouseEnter={e => {
                                  e.currentTarget.style.transform =
                                    'scale(1.02)';
                                  e.currentTarget.style.boxShadow =
                                    '0 8px 30px rgba(0,0,0,0.12)';
                                  e.currentTarget.style.zIndex = '1';
                                  e.currentTarget.style.borderLeftWidth = '6px';
                                }}
                                onMouseLeave={e => {
                                  e.currentTarget.style.transform = 'scale(1)';
                                  e.currentTarget.style.boxShadow = 'none';
                                  e.currentTarget.style.zIndex = 'auto';
                                  e.currentTarget.style.borderLeftWidth = '4px';
                                }}
                              >
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    60% a 62,49%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 490,00</span>
                                </td>
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    85% a 87,49%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 880,00</span>
                                </td>
                              </tr>
                              <tr
                                className="border-bottom"
                                style={{
                                  backgroundColor: 'rgba(13, 110, 253, 0.05)',
                                  borderLeft:
                                    '4px solid rgba(13, 110, 253, 0.2)',
                                  transition:
                                    'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }}
                                onMouseEnter={e => {
                                  e.currentTarget.style.transform =
                                    'scale(1.02)';
                                  e.currentTarget.style.boxShadow =
                                    '0 8px 30px rgba(0,0,0,0.12)';
                                  e.currentTarget.style.zIndex = '1';
                                  e.currentTarget.style.borderLeftWidth = '6px';
                                }}
                                onMouseLeave={e => {
                                  e.currentTarget.style.transform = 'scale(1)';
                                  e.currentTarget.style.boxShadow = 'none';
                                  e.currentTarget.style.zIndex = 'auto';
                                  e.currentTarget.style.borderLeftWidth = '4px';
                                }}
                              >
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    62,50% a 64,99%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 525,00</span>
                                </td>
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    87,50% a 89,99%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 925,00</span>
                                </td>
                              </tr>
                              <tr
                                className="border-bottom"
                                style={{
                                  backgroundColor: 'rgba(13, 110, 253, 0.05)',
                                  borderLeft:
                                    '4px solid rgba(13, 110, 253, 0.2)',
                                  transition:
                                    'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }}
                                onMouseEnter={e => {
                                  e.currentTarget.style.transform =
                                    'scale(1.02)';
                                  e.currentTarget.style.boxShadow =
                                    '0 8px 30px rgba(0,0,0,0.12)';
                                  e.currentTarget.style.zIndex = '1';
                                  e.currentTarget.style.borderLeftWidth = '6px';
                                }}
                                onMouseLeave={e => {
                                  e.currentTarget.style.transform = 'scale(1)';
                                  e.currentTarget.style.boxShadow = 'none';
                                  e.currentTarget.style.zIndex = 'auto';
                                  e.currentTarget.style.borderLeftWidth = '4px';
                                }}
                              >
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    65% a 67,49%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 560,00</span>
                                </td>
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    90% a 92,49%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 970,00</span>
                                </td>
                              </tr>
                              <tr
                                className="border-bottom"
                                style={{
                                  backgroundColor: 'rgba(13, 110, 253, 0.05)',
                                  borderLeft:
                                    '4px solid rgba(13, 110, 253, 0.2)',
                                  transition:
                                    'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }}
                                onMouseEnter={e => {
                                  e.currentTarget.style.transform =
                                    'scale(1.02)';
                                  e.currentTarget.style.boxShadow =
                                    '0 8px 30px rgba(0,0,0,0.12)';
                                  e.currentTarget.style.zIndex = '1';
                                  e.currentTarget.style.borderLeftWidth = '6px';
                                }}
                                onMouseLeave={e => {
                                  e.currentTarget.style.transform = 'scale(1)';
                                  e.currentTarget.style.boxShadow = 'none';
                                  e.currentTarget.style.zIndex = 'auto';
                                  e.currentTarget.style.borderLeftWidth = '4px';
                                }}
                              >
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    67,50% a 69,99%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 595,00</span>
                                </td>
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    92,50% a 94,99%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 1.015,00</span>
                                </td>
                              </tr>
                              <tr
                                className="border-bottom"
                                style={{
                                  backgroundColor: 'rgba(13, 110, 253, 0.05)',
                                  borderLeft:
                                    '4px solid rgba(13, 110, 253, 0.2)',
                                  transition:
                                    'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }}
                                onMouseEnter={e => {
                                  e.currentTarget.style.transform =
                                    'scale(1.02)';
                                  e.currentTarget.style.boxShadow =
                                    '0 8px 30px rgba(0,0,0,0.12)';
                                  e.currentTarget.style.zIndex = '1';
                                  e.currentTarget.style.borderLeftWidth = '6px';
                                }}
                                onMouseLeave={e => {
                                  e.currentTarget.style.transform = 'scale(1)';
                                  e.currentTarget.style.boxShadow = 'none';
                                  e.currentTarget.style.zIndex = 'auto';
                                  e.currentTarget.style.borderLeftWidth = '4px';
                                }}
                              >
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    70% a 72,49%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 630,00</span>
                                </td>
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    95% a 97,49%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 1.060,00</span>
                                </td>
                              </tr>
                              <tr
                                className="border-bottom"
                                style={{
                                  backgroundColor: 'rgba(13, 110, 253, 0.05)',
                                  borderLeft:
                                    '4px solid rgba(13, 110, 253, 0.2)',
                                  transition:
                                    'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }}
                                onMouseEnter={e => {
                                  e.currentTarget.style.transform =
                                    'scale(1.02)';
                                  e.currentTarget.style.boxShadow =
                                    '0 8px 30px rgba(0,0,0,0.12)';
                                  e.currentTarget.style.zIndex = '1';
                                  e.currentTarget.style.borderLeftWidth = '6px';
                                }}
                                onMouseLeave={e => {
                                  e.currentTarget.style.transform = 'scale(1)';
                                  e.currentTarget.style.boxShadow = 'none';
                                  e.currentTarget.style.zIndex = 'auto';
                                  e.currentTarget.style.borderLeftWidth = '4px';
                                }}
                              >
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    72,50% a 74,99%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 665,00</span>
                                </td>
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    97,50% ou mais
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 1.100,00</span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                )}

                {(exibeApenasSetClube || exibeAmbas) && (
                  <Col xl={colSize} lg={colSize} md="12">
                    <Card className="h-100 shadow-sm border-0">
                      <Card.Header className="bg-gradient bg-primary text-white border-0 py-3">
                        <div className="d-flex justify-content-between align-items-center">
                          <h6 className="mb-0 fw-bold">
                            <i className="fas fa-table me-2"></i>
                            Tabela SetClube
                          </h6>
                        </div>
                      </Card.Header>
                      <Card.Body className="p-4">
                        <div
                          className="table-responsive"
                          style={{ overflow: 'hidden' }}
                        >
                          <table className="table table-hover align-middle mb-0">
                            <thead>
                              <tr className="border-0">
                                <th className="border-0 bg-transparent text-muted small fw-semibold text-uppercase text-center pb-3">
                                  Percentual
                                </th>
                                <th className="border-0 bg-transparent text-muted small fw-semibold text-uppercase text-end pb-3">
                                  Remuneração
                                </th>
                                <th className="border-0 bg-transparent text-muted small fw-semibold text-uppercase text-center pb-3">
                                  Percentual
                                </th>
                                <th className="border-0 bg-transparent text-muted small fw-semibold text-uppercase text-end pb-3">
                                  Remuneração
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                className="border-bottom"
                                style={{
                                  backgroundColor: 'rgba(13, 110, 253, 0.05)',
                                  borderLeft:
                                    '4px solid rgba(13, 110, 253, 0.2)',
                                  transition:
                                    'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }}
                                onMouseEnter={e => {
                                  e.currentTarget.style.transform =
                                    'scale(1.02)';
                                  e.currentTarget.style.boxShadow =
                                    '0 8px 30px rgba(0,0,0,0.12)';
                                  e.currentTarget.style.zIndex = '1';
                                  e.currentTarget.style.borderLeftWidth = '6px';
                                }}
                                onMouseLeave={e => {
                                  e.currentTarget.style.transform = 'scale(1)';
                                  e.currentTarget.style.boxShadow = 'none';
                                  e.currentTarget.style.zIndex = 'auto';
                                  e.currentTarget.style.borderLeftWidth = '4px';
                                }}
                              >
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    80% a 80,99%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 120,00</span>
                                </td>
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    90% a 90,99%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 320,00</span>
                                </td>
                              </tr>
                              <tr
                                className="border-bottom"
                                style={{
                                  backgroundColor: 'rgba(13, 110, 253, 0.05)',
                                  borderLeft:
                                    '4px solid rgba(13, 110, 253, 0.2)',
                                  transition:
                                    'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }}
                                onMouseEnter={e => {
                                  e.currentTarget.style.transform =
                                    'scale(1.02)';
                                  e.currentTarget.style.boxShadow =
                                    '0 8px 30px rgba(0,0,0,0.12)';
                                  e.currentTarget.style.zIndex = '1';
                                  e.currentTarget.style.borderLeftWidth = '6px';
                                }}
                                onMouseLeave={e => {
                                  e.currentTarget.style.transform = 'scale(1)';
                                  e.currentTarget.style.boxShadow = 'none';
                                  e.currentTarget.style.zIndex = 'auto';
                                  e.currentTarget.style.borderLeftWidth = '4px';
                                }}
                              >
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    81% a 81,99%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 140,00</span>
                                </td>
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    91% a 91,99%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 340,00</span>
                                </td>
                              </tr>
                              <tr
                                className="border-bottom"
                                style={{
                                  backgroundColor: 'rgba(13, 110, 253, 0.05)',
                                  borderLeft:
                                    '4px solid rgba(13, 110, 253, 0.2)',
                                  transition:
                                    'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }}
                                onMouseEnter={e => {
                                  e.currentTarget.style.transform =
                                    'scale(1.02)';
                                  e.currentTarget.style.boxShadow =
                                    '0 8px 30px rgba(0,0,0,0.12)';
                                  e.currentTarget.style.zIndex = '1';
                                  e.currentTarget.style.borderLeftWidth = '6px';
                                }}
                                onMouseLeave={e => {
                                  e.currentTarget.style.transform = 'scale(1)';
                                  e.currentTarget.style.boxShadow = 'none';
                                  e.currentTarget.style.zIndex = 'auto';
                                  e.currentTarget.style.borderLeftWidth = '4px';
                                }}
                              >
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    82% a 82,99%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 160,00</span>
                                </td>
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    92% a 92,99%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 360,00</span>
                                </td>
                              </tr>
                              <tr
                                className="border-bottom"
                                style={{
                                  backgroundColor: 'rgba(13, 110, 253, 0.05)',
                                  borderLeft:
                                    '4px solid rgba(13, 110, 253, 0.2)',
                                  transition:
                                    'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }}
                                onMouseEnter={e => {
                                  e.currentTarget.style.transform =
                                    'scale(1.02)';
                                  e.currentTarget.style.boxShadow =
                                    '0 8px 30px rgba(0,0,0,0.12)';
                                  e.currentTarget.style.zIndex = '1';
                                  e.currentTarget.style.borderLeftWidth = '6px';
                                }}
                                onMouseLeave={e => {
                                  e.currentTarget.style.transform = 'scale(1)';
                                  e.currentTarget.style.boxShadow = 'none';
                                  e.currentTarget.style.zIndex = 'auto';
                                  e.currentTarget.style.borderLeftWidth = '4px';
                                }}
                              >
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    83% a 83,99%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 180,00</span>
                                </td>
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    93% a 93,99%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 380,00</span>
                                </td>
                              </tr>
                              <tr
                                className="border-bottom"
                                style={{
                                  backgroundColor: 'rgba(13, 110, 253, 0.05)',
                                  borderLeft:
                                    '4px solid rgba(13, 110, 253, 0.2)',
                                  transition:
                                    'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }}
                                onMouseEnter={e => {
                                  e.currentTarget.style.transform =
                                    'scale(1.02)';
                                  e.currentTarget.style.boxShadow =
                                    '0 8px 30px rgba(0,0,0,0.12)';
                                  e.currentTarget.style.zIndex = '1';
                                  e.currentTarget.style.borderLeftWidth = '6px';
                                }}
                                onMouseLeave={e => {
                                  e.currentTarget.style.transform = 'scale(1)';
                                  e.currentTarget.style.boxShadow = 'none';
                                  e.currentTarget.style.zIndex = 'auto';
                                  e.currentTarget.style.borderLeftWidth = '4px';
                                }}
                              >
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    84% a 84,99%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 200,00</span>
                                </td>
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    94% a 94,99%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 400,00</span>
                                </td>
                              </tr>
                              <tr
                                className="border-bottom"
                                style={{
                                  backgroundColor: 'rgba(13, 110, 253, 0.05)',
                                  borderLeft:
                                    '4px solid rgba(13, 110, 253, 0.2)',
                                  transition:
                                    'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }}
                                onMouseEnter={e => {
                                  e.currentTarget.style.transform =
                                    'scale(1.02)';
                                  e.currentTarget.style.boxShadow =
                                    '0 8px 30px rgba(0,0,0,0.12)';
                                  e.currentTarget.style.zIndex = '1';
                                  e.currentTarget.style.borderLeftWidth = '6px';
                                }}
                                onMouseLeave={e => {
                                  e.currentTarget.style.transform = 'scale(1)';
                                  e.currentTarget.style.boxShadow = 'none';
                                  e.currentTarget.style.zIndex = 'auto';
                                  e.currentTarget.style.borderLeftWidth = '4px';
                                }}
                              >
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    85% a 85,99%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 220,00</span>
                                </td>
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    95% a 95,99%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 420,00</span>
                                </td>
                              </tr>
                              <tr
                                className="border-bottom"
                                style={{
                                  backgroundColor: 'rgba(13, 110, 253, 0.05)',
                                  borderLeft:
                                    '4px solid rgba(13, 110, 253, 0.2)',
                                  transition:
                                    'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }}
                                onMouseEnter={e => {
                                  e.currentTarget.style.transform =
                                    'scale(1.02)';
                                  e.currentTarget.style.boxShadow =
                                    '0 8px 30px rgba(0,0,0,0.12)';
                                  e.currentTarget.style.zIndex = '1';
                                  e.currentTarget.style.borderLeftWidth = '6px';
                                }}
                                onMouseLeave={e => {
                                  e.currentTarget.style.transform = 'scale(1)';
                                  e.currentTarget.style.boxShadow = 'none';
                                  e.currentTarget.style.zIndex = 'auto';
                                  e.currentTarget.style.borderLeftWidth = '4px';
                                }}
                              >
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    86% a 86,99%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 240,00</span>
                                </td>
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    96% a 96,99%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 440,00</span>
                                </td>
                              </tr>
                              <tr
                                className="border-bottom"
                                style={{
                                  backgroundColor: 'rgba(13, 110, 253, 0.05)',
                                  borderLeft:
                                    '4px solid rgba(13, 110, 253, 0.2)',
                                  transition:
                                    'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }}
                                onMouseEnter={e => {
                                  e.currentTarget.style.transform =
                                    'scale(1.02)';
                                  e.currentTarget.style.boxShadow =
                                    '0 8px 30px rgba(0,0,0,0.12)';
                                  e.currentTarget.style.zIndex = '1';
                                  e.currentTarget.style.borderLeftWidth = '6px';
                                }}
                                onMouseLeave={e => {
                                  e.currentTarget.style.transform = 'scale(1)';
                                  e.currentTarget.style.boxShadow = 'none';
                                  e.currentTarget.style.zIndex = 'auto';
                                  e.currentTarget.style.borderLeftWidth = '4px';
                                }}
                              >
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    87% a 87,99%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 260,00</span>
                                </td>
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    97% a 97,99%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 460,00</span>
                                </td>
                              </tr>
                              <tr
                                className="border-bottom"
                                style={{
                                  backgroundColor: 'rgba(13, 110, 253, 0.05)',
                                  borderLeft:
                                    '4px solid rgba(13, 110, 253, 0.2)',
                                  transition:
                                    'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }}
                                onMouseEnter={e => {
                                  e.currentTarget.style.transform =
                                    'scale(1.02)';
                                  e.currentTarget.style.boxShadow =
                                    '0 8px 30px rgba(0,0,0,0.12)';
                                  e.currentTarget.style.zIndex = '1';
                                  e.currentTarget.style.borderLeftWidth = '6px';
                                }}
                                onMouseLeave={e => {
                                  e.currentTarget.style.transform = 'scale(1)';
                                  e.currentTarget.style.boxShadow = 'none';
                                  e.currentTarget.style.zIndex = 'auto';
                                  e.currentTarget.style.borderLeftWidth = '4px';
                                }}
                              >
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    88% a 88,99%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 280,00</span>
                                </td>
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    98% a 98,99%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 480,00</span>
                                </td>
                              </tr>
                              <tr
                                className="border-bottom"
                                style={{
                                  backgroundColor: 'rgba(13, 110, 253, 0.05)',
                                  borderLeft:
                                    '4px solid rgba(13, 110, 253, 0.2)',
                                  transition:
                                    'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }}
                                onMouseEnter={e => {
                                  e.currentTarget.style.transform =
                                    'scale(1.02)';
                                  e.currentTarget.style.boxShadow =
                                    '0 8px 30px rgba(0,0,0,0.12)';
                                  e.currentTarget.style.zIndex = '1';
                                  e.currentTarget.style.borderLeftWidth = '6px';
                                }}
                                onMouseLeave={e => {
                                  e.currentTarget.style.transform = 'scale(1)';
                                  e.currentTarget.style.boxShadow = 'none';
                                  e.currentTarget.style.zIndex = 'auto';
                                  e.currentTarget.style.borderLeftWidth = '4px';
                                }}
                              >
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    89% a 89,99%
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 300,00</span>
                                </td>
                                <td className="text-center py-3 border-0">
                                  <span className="fw-semibold">
                                    99% ou mais
                                  </span>
                                </td>
                                <td className="text-end py-3 border-0">
                                  <span className="fw-bold">R$ 500,00</span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                )}
              </Row>
            );
          })()}
        </Container>
      ) : (
        <div className="text-center mt-5 py-5">
          <div className="mb-3">
            <i className="fas fa-search fa-3x text-muted"></i>
          </div>
          <h4 className="text-muted">Nenhum registro encontrado!</h4>
          <p className="text-muted">Ajuste os filtros e tente novamente.</p>
        </div>
      )}
    </>
  );
};
export default ProdutividadeCobradores;
